// extracted by mini-css-extract-plugin
export default {"commonLikeWrap":"LikeAndCoin_commonLikeWrap__v08SM","block":"LikeAndCoin_block__tUwrE","line":"LikeAndCoin_line__E1PPn"};